export default __webpack_public_path__ + "b483b1e956dd15bdc1c878f88df00235.svg";